import { Shot } from '@/types/greenroom/shots.types';
import { Post } from '../helpers';

const BulkEditShots = ({ shots, deprecated = '' }: { shots: Shot[]; deprecated?: string }) => {
  const meetingId = shots?.[0].meeting ?? 0;
  return Post({
    host: import.meta.env.VITE_GREENROOM_API,
    path: '/v2/greenroom/shots/bulk-edit',
    includeBlToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
    body: {
      shots,
      meetingId,
      deprecated,
    },
  });
};

export default BulkEditShots;
